// gerado por work/gerar_pdp.py - nao editar a mao
(function () {
  function ligar() {
    var alvo = document.getElementById('ionix-sg-overlay') || document.querySelector('.ix-pp');
    if (!alvo) return;
    var raiz = alvo.closest('.product-info') || document.body;
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';
    /* guia */
    (function() {
      var overlay = document.getElementById('ionix-sg-cutout-overlay');
      var openBtn = document.getElementById('ionix-sg-cutout-open');
      var closeBtn = document.getElementById('ionix-sg-cutout-close');

      if (!overlay || !openBtn || !closeBtn) return;

      function openModal() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function closeModal() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

      openBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
      });
    })();

    /* confianca */
    (function(){var f=document.getElementById('ix-flag'),c=document.getElementById('ix-country'),s=document.getElementById('ix-sold');/* country + flag rendered server-side from Shopify Markets (localization.country) */var n=Math.floor(Math.random()*5)+9;if(s)s.textContent="__N__ sold in the last hour".replace('__N__', n);(function loop(){setTimeout(function(){var r=Math.random();if(r<.35)n+=1;else if(r<.5)n+=2;if(n>22)n=8+Math.floor(Math.random()*4);if(s){s.style.opacity='0';setTimeout(function(){s.textContent="__N__ sold in the last hour".replace('__N__', n);s.style.opacity='1'},200)}loop()},10000+Math.floor(Math.random()*15000))})()});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
  var pendente = null;
  new MutationObserver(function () {
    clearTimeout(pendente);
    pendente = setTimeout(ligar, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
